import type { FieldOption } from '../common/fields';

// One-off enrols and makeups fill a lesson only to MAX_LESSON_SIZE and class students add up to
// MAX_CLASS_SIZE, so outside a roster changeover a lesson holds at most 24, and markRoll's
// transaction (the lesson plus an enrolment and a student per enrolled student) exceeds DynamoDB's
// 100-item limit only at 50 students
export const MAX_CLASS_SIZE = 12;
export const DESIRED_CLASS_SIZE = 9;
export const MAX_LESSON_SIZE = 12;
export const DESIRED_LESSON_SIZE = 9;

// The number of trial lessons a student can have before they are no longer considered a trial student
export const TRIAL_LESSONS_COUNT = 2;

// This limit exists as the lesson counter format is ####
export const MAX_LESSON_COUNT = 9999;

const queryAttributes = [
  'subject',
  'course',
  'stream',
  'teacher',
  'marker',
  'day',
  'location',
  'room',
  'tag',
  'schoolId',
  'active',
  'classId',
] as const;
const listAttributes = [
  'subject',
  'classId',
  'course',
  'stream',
  'streams',
  'day',
  'time',
  'teacher',
  'teacherName',
  'marker',
  'markerName',
  'tags',
  'studentCount',
  'studentCap',
  'students',
  'active',
  'location',
  'room',
  'notes',
  'waitlist',
  'schoolTag',
  'slackId',
  'slackChannelName',
  'nextLessonDatetime',
  'allowMakeups',
] as const;
const getAttributes = [...listAttributes, 'permissionGroup', 'students', 'remindBreaks'] as const;
// `stream` is the entry `streams` holds for the class course, written by the entity from the
// map; the API takes the map, never the stream on its own
const updateAttributes = [
  'course',
  'stream',
  'streams',
  'day',
  'time',
  'teacher',
  'teacherName',
  'marker',
  'markerName',
  'notes',
  'tags',
  'studentCap',
  'location',
  'room',
  'remindBreaks',
  'schoolTag',
  'allowMakeups',
] as const;

export const ClassAttributes = {
  Query: queryAttributes,
  List: listAttributes,
  Get: getAttributes,
  Update: updateAttributes,
};

/** A class's day as its form offers it, `-1` for a class with none. */
export const CLASS_DAY_OPTIONS: readonly (FieldOption<number> & { shortLabel: string })[] = [
  { value: -1, label: 'Undetermined', shortLabel: 'N/A' },
  { value: 1, label: 'Monday', shortLabel: 'Mon' },
  { value: 2, label: 'Tuesday', shortLabel: 'Tue' },
  { value: 3, label: 'Wednesday', shortLabel: 'Wed' },
  { value: 4, label: 'Thursday', shortLabel: 'Thu' },
  { value: 5, label: 'Friday', shortLabel: 'Fri' },
  { value: 6, label: 'Saturday', shortLabel: 'Sat' },
  { value: 0, label: 'Sunday', shortLabel: 'Sun' },
];
